class ResumeStyle {

    constructor() {

        this.large = {

            Container: {
                width: "100%",
                textAlign: "center",
                alignContent: "center",
                marginTop: 0,
                fontFamily: "'Libre Franklin'",
                color: "#e0e0e0"
            },
            Download: {
                content: {
                    width: "100%",
                    alignContent: "center",
                    margin: 0,
                    marginBottom: 0,
                    padding: 0,
                },
                section: {
                    marginTop: 25,
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginBottom: 0,
                    textAlign: "left",
                    padding: 0,
                    width: "80%",
                },
                text: {
                    color: "#c0c0c0",
                    marginBottom: 0,
                },
            },
            Header: {
                section: {
                    width: "100%",
                    textAlign: "center",
                    alignContent: "center",
                },
                name: {
                    textTransform: "uppercase",
                    fontWeight: 700,
                    fontSize: 24,
                    width: "100%",
                    textAlign: "center",
                    alignContent: "center",
                    padding: 0,
                    margin: 0,
                    marginBottom: 5,
                    color: "#41c4fc",
                },
                address: {
                    width: "100%",
                    textAlign: "center",
                    alignContent: "center",
                    padding: 0,
                    margin: 0,
                    color: "#c0c0c0"
                },
                email: {
                    width: "100%",
                    textAlign: "center",
                    alignContent: "center",
                    padding: 0,
                    margin: 0,
                    color: "#c0c0c0"
                },
                phone: {
                    width: "100%",
                    textAlign: "center",
                    alignContent: "center",
                    padding: 0,
                    margin: 0,
                    color: "#c0c0c0"
                },
            },
            Body: {
                width: "80%",
                textAlign: "center",
                marginLeft: "auto",
                marginRight: "auto",
                padding:0,
                Introduction: {
                    width: "100%",
                    textAlign: "left",
                    margin: 0,
                    padding: 0,
                    title: {
                        textTransform: "uppercase",
                        fontWeight: 700,
                        width: "100%",
                        textAlign: "left",
                        marginBottom: 5,
                        color: "#e59409",
                    },
                    text: {

                    },
                },
                Section: {
                    width: "100%",
                    textAlign: "left",
                    margin: 0,
                    padding: 0,
                    title: {
                        textTransform: "uppercase",
                        fontWeight: 700,
                        width: "100%",
                        textAlign: "left",
                        marginBottom: 5,
                        color: "#e59409",
                    },
                    text: {

                    },
                    subsection: {
                        width: "90%",
                        marginLeft: "auto",
                        marginRight: "auto",
                        padding: 0,
                        title: {
                            fontWeight: "normal",
                            fontStyle: "italic",
                            textTransform: "capitalize",
                            width: "100%",
                            textAlign: "left",
                            marginBottom: 0,
                        },
                    },
                    school: {
                        margin: 0,
                        paddingTop: 0,
                        paddingLeft: 10,
                    },
                    schoolInfo: {
                        margin: 0,
                        paddingTop: 0,
                        paddingLeft: 20,
                    }
                },
                SinceSubSection: {
                    width: "95%",
                    textAlign: "left",
                    marginLeft: "auto",
                    marginRight: "auto",
                    paddingTop: 5,
                    Row: {
                        width: "90%",
                        padding: 0,
                        marginLeft: "2%",
                        display: "flex",
                        justifyContent: "space-between",
                        Name: {
                            width: 200,
                            Heading: {
                                fontWeight: "normal",
                                fontStyle: "italic",
                                textTransform: "capitalize",
                                textAlign: "left",
                                width: 250,
                                borderBottom: "1px solid #e0e0e0",
                                marginTop: 8,
                                marginBottom: 8,
                            },
                            Data: {
                                fontWeight: "normal",
                                fontStyle: "normal",
                                textTransform: "capitalize",
                                textAlign: "left",
                                width: 250,
                            },
                        },
                        Years: {
                            width: 100,
                            Heading: {
                                fontWeight: "normal",
                                fontStyle: "italic",
                                textTransform: "capitalize",
                                textAlign: "left",
                                width: 100,
                                borderBottom: "1px solid #e0e0e0",
                                marginTop: 8,
                                marginBottom: 8,
                            },
                            Data: {
                                fontWeight: "normal",
                                fontStyle: "normal",
                                textTransform: "capitalize",
                                textAlign: "left",
                                width: 100,
                            },
                        },
                        Since: {
                            width: 100,
                            Heading: {
                                fontWeight: "normal",
                                fontStyle: "italic",
                                textTransform: "capitalize",
                                textAlign: "right",
                                width: 100,
                                borderBottom: "1px solid #e0e0e0",
                                marginTop: 8,
                                marginBottom: 8,
                            },
                            Data: {
                                fontWeight: "normal",
                                fontStyle: "normal",
                                textTransform: "capitalize",
                                textAlign: "right",
                                width: 100,
                            },
                        },
                    },
                    title: {
                        fontWeight: "normal",
                        fontStyle: "italic",
                        textTransform: "capitalize",
                        width: "100%",
                        textAlign: "left",
                        marginBottom: 0,
                        marginTop: 0,
                        padding: 0,
                    },
                },
                ListSubSection: {
                    width: "95%",
                    textAlign: "left",
                    marginLeft: "auto",
                    marginRight: "auto",
                    padding: 0,
                    title: {
                        fontWeight: "normal",
                        fontStyle: "italic",
                        textTransform: "capitalize",
                        width: "100%",
                        textAlign: "left",
                        marginBottom: 5,
                    },
                },
                GroupedListSubSection: {
                    title: {
                        fontWeight: "normal",
                        fontStyle: "italic",
                        textTransform: "capitalize",
                        width: "100%",
                        textAlign: "left",
                        marginBottom: 0,
                        marginTop: 0,
                        padding: 0,
                    },
                    Group: {
                        padding: 0,
                        marginLeft: 10,
                        item: {
                            width: 150,
                            marginBottom: 10,
                            padding: 0,
                            marginTop: 0,
                        },
                        ItemListArea: {
                            display: "flex",
                            justifyContent: "flex-start",
                            flexWrap: "wrap",
                            marginTop: 8,
                            marginLeft: 10,
                            padding: 0,
                        },
                        title: {
                            fontWeight: "normal",
                            fontStyle: "normal",
                            textTransform: "capitalize",
                            width: "auto",
                            textAlign: "left",
                            marginBottom: 0,
                            marginTop: 0,
                            padding: 0,
                            borderBottom: "1px solid #e0e0e0",
                        },
                    },
                    Heading: {
                        fontWeight: "normal",
                        fontStyle: "italic",
                        textTransform: "capitalize",
                        width: "100%",
                        textAlign: "left",
                        marginBottom: 5,
                        padding: 0,
                        borderBottom: "1px solid #e0e0e0",
                        title: {
                            fontWeight: "normal",
                            fontStyle: "italic",
                            textTransform: "capitalize",
                            width: "100%",
                            textAlign: "left",
                            marginBottom: 0,
                            padding: 0,
                            borderBottom: "1px solid #e0e0e0",
                        },
                    },
                },
                List: {
                    display: "flex",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    padding: 0,
                    item: {
                        width: 150,
                        marginBottom: 10,
                    },
                },
            },
        }

        this.smallest = this.deepClone(this.large, null);
        this.smallest.Header.name.fontSize = 18;
        this.smallest.Body.Section.width= "98%";
        this.smallest.Body.SinceSubSection.Row.Years.Heading.display = "none";
        this.smallest.Body.SinceSubSection.Row.Years.Data.display = "none";

        this.small = this.deepClone(this.large, null);
        this.small.Body.SinceSubSection.Row.Years.Heading.display = "none";
        this.small.Body.SinceSubSection.Row.Years.Data.display = "none";

        this.medium = this.deepClone(this.large, null);

        this.largest = this.deepClone(this.large, null);

        this.currStyles = this.large;
    }

    deepClone(initalObj, finalObj) {
        var obj = finalObj || {};
        for (var i in initalObj) {
            var prop = initalObj[i];

            if(prop === obj) {
                continue;
            }

            if (typeof prop === 'object') {
                obj[i] = this.deepClone(prop, null);
            } else {
                obj[i] = prop;
            }
        }
        return obj;
    }

    setWidth(width) {
        if(width < 321) {
            this.currStyles = this.smallest;
        } else if(width < 481) {
            this.currStyles = this.small;
        } else if(width < 769) {
            this.currStyles = this.medium;
        } else if(width < 1025) {
            this.currStyles = this.large;
        } else {
            this.currStyles = this.largest;
        }
    }

}

export default ResumeStyle



// WEBPACK FOOTER //
// src/ResumeAndDocs/ResumeStyle.js